import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Person from 'components/CommonUI/svgIcons/Person'
import Door from 'components/CommonUI/svgIcons/Door'
import ProfileAvatar from './ProfileAvatar'
import { routingConstants } from 'constants/routingConstants'
import { logout } from 'redux/reducers/profile'

import DropdownMenu from 'components/CommonUI/Dropdown'

export default function ProfileSection() {
  const history = useHistory()
  const dispatch = useDispatch()

  const handleLogout = () => {
    dispatch(logout())
  }

  const handleClickProfile = () => {
    history.push(routingConstants.profile)
  }

  return (
    <div className=" header_profile_section">
      <DropdownMenu
        controlComponent={ProfileAvatar}
        styleMenu={{
          left: 'unset',
          right: '-10px',
          top: '90%',
        }}
      >
        <DropdownMenu.Item onClick={handleClickProfile}>
          <span className="profile_drop_item">
            <Person className="profile_drop_item_icon" />
            My profile
          </span>
        </DropdownMenu.Item>
        <DropdownMenu.Item onClick={handleLogout}>
          <span className="profile_drop_item">
            <Door className="profile_drop_item_icon" />
            Log out
          </span>
        </DropdownMenu.Item>
      </DropdownMenu>
    </div>
  )
}
